import './axios'
import './chartist'
import './vuetify'



// WEBPACK FOOTER //
// ./VueSrc/Common/Components/materialcomponents/plugins/index.js